import ArrivalTimePill from '../arrivalTimePill/ArrivalTimePill';

export enum EventStatus {
  Pending = 1,
  OnTime,
  Late,
  Cancelled,
}

export type EventItemStatusProps = {
  status: EventStatus;
  arrival?: string;
};

const EventItemStatus = ({ status, arrival }: EventItemStatusProps) => {
  if (status === EventStatus.Pending) {
    return (
      <div className="relative">
        <div
          role="progressbar"
          aria-valuenow={75}
          aria-valuemin={0}
          aria-valuemax={100}
          className="relative mx-4 flex h-6 w-[192px] overflow-visible bg-gray-dots bg-[position:50%_40%] bg-no-repeat before:absolute before:top-1/2 before:left-0 before:h-2 before:w-2 before:-translate-y-2/3 before:rounded-full before:bg-dots-grey before:content-[''] after:absolute after:right-0 after:top-1/2 after:h-2 after:w-2 after:-translate-y-2/3 after:rounded-full after:bg-dots-grey after:content-['']"
        >
          {' '}
        </div>
      </div>
    );
  }

  if (status === EventStatus.OnTime) {
    return (
      <div className="relative">
        <div
          role="progressbar"
          aria-valuenow={75}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label="OnTimeArrival"
          className="relative mx-4 flex h-6 w-[192px] items-center overflow-visible bg-green-dots bg-[position:50%_40%] bg-no-repeat before:absolute before:top-1/2 before:left-0 before:h-2 before:w-2 before:-translate-y-2/3 before:rounded-full before:bg-design-green before:content-[''] after:absolute after:right-0 after:top-1/2 after:h-2 after:w-2 after:-translate-y-2/3 after:rounded-full after:bg-design-green after:content-['']"
        >
          <div className="flex h-8 w-[55%] justify-end">
            <ArrivalTimePill
              arrivalTime={arrival ?? ''}
              status={EventStatus.OnTime}
            />
          </div>
        </div>
      </div>
    );
  }

  if (status === EventStatus.Cancelled) {
    return (
      <div className="relative">
        <div
          role="progressbar"
          aria-valuenow={75}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label="LateTimeArrival"
          className="bg-yellow-dots relative mx-4 flex h-6 w-[80px] items-center overflow-visible bg-[position:50%_40%] bg-no-repeat before:absolute before:top-1/2 before:left-0 before:h-2 before:w-2 before:-translate-y-2/3 before:rounded-full before:bg-yellow before:content-[''] after:absolute after:right-0 after:top-1/2 after:h-2 after:w-2 after:-translate-y-2/3 after:rounded-full after:bg-yellow after:content-[''] xl:w-[100px] 2xl:w-[192px]"
        >
          {' '}
        </div>
        <ArrivalTimePill
          arrivalTime={arrival ?? ''}
          status={EventStatus.Cancelled}
        />
      </div>
    );
  }

  return (
    <div className="relative">
      <div
        role="progressbar"
        aria-valuenow={75}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="LateTimeArrival"
        className="relative mx-4 flex h-6 w-[80px] items-center overflow-visible bg-red-dots bg-[position:50%_40%] bg-no-repeat before:absolute before:top-1/2 before:left-0 before:h-2 before:w-2 before:-translate-y-2/3 before:rounded-full before:bg-design-red before:content-[''] after:absolute after:right-0 after:top-1/2 after:h-2 after:w-2 after:-translate-y-2/3 after:rounded-full after:bg-design-red after:content-[''] xl:w-[100px] 2xl:w-[192px]"
      >
        {' '}
      </div>
      <ArrivalTimePill
        arrivalTime={arrival ?? ''}
        status={EventStatus.Late}
      />
    </div>
  );
};

EventItemStatus.defaultProps = {
  arrival: '',
};

export default EventItemStatus;
